<template>
  <div class="add-purchase-container">
    <ds-page-header :title="$t('addPurchaseApply.page.title')" :subtitle="$t('addPurchaseApply.page.subtitle')">
      <template #extra>
        <el-button size="small" icon="el-icon-back" @click="goBack">{{ $t('common.back') }}</el-button>
        <el-button type="primary" size="small" icon="el-icon-check" @click="_applyPurchaseSummit">
          {{ $t('addPurchaseApply.submit') }}
        </el-button>
      </template>
    </ds-page-header>

    <div class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('addPurchaseApply.purchaser') }}</span>
      </div>
      <el-form label-width="120px" class="ds-form">
        <el-row :gutter="16">
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('addPurchaseApply.warehouse')">
              <el-select v-model="addPurchaseApplyInfo.shId" @change="_computeFlow" style="width:100%" clearable
                :placeholder="$t('addPurchaseApply.requiredSelectWarehouse')">
                <el-option disabled value="" :label="$t('addPurchaseApply.requiredSelectWarehouse')"></el-option>
                <el-option v-for="(item, index) in addPurchaseApplyInfo.storehouses" :key="index" :label="item.shName" :value="item.shId" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('addPurchaseApply.contact')">
              <el-input :placeholder="$t('addPurchaseApply.requiredContact')" v-model="addPurchaseApplyInfo.endUserName" clearable />
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8">
            <el-form-item :label="$t('addPurchaseApply.phone')">
              <el-input :placeholder="$t('addPurchaseApply.requiredPhone')" v-model="addPurchaseApplyInfo.endUserTel" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('addPurchaseApply.applyDesc')">
              <el-input type="textarea" :rows="2" :placeholder="$t('addPurchaseApply.requiredDesc')" v-model="addPurchaseApplyInfo.description" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="ds-panel">
      <ds-toolbar :show-column-setting="false" :show-density="false" :show-refresh="false">
        <template #left>
          <span class="ds-panel__title">{{ $t('addPurchaseApply.purchaseItems') }}</span>
        </template>
        <template #right>
          <el-button type="primary" size="small" icon="el-icon-plus" @click="_openSelectResourceStoreInfoModel">
            {{ $t('addPurchaseApply.select') }}
          </el-button>
        </template>
      </ds-toolbar>
      <ds-data-table :data="addPurchaseApplyInfo.resourceStores" border :empty-description="$t('addPurchaseApply.page.empty')">
        <el-table-column :label="$t('addPurchaseApply.itemType')" align="center" min-width="140">
          <template slot-scope="scope">
            {{ scope.row.parentRstName ? scope.row.parentRstName : '-' }} &gt; {{ scope.row.rstName ? scope.row.rstName : '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('addPurchaseApply.itemNameCode')" align="center" min-width="160">
          <template slot-scope="scope">
            {{ scope.row.resName }}({{ scope.row.resCode }})
          </template>
        </el-table-column>
        <el-table-column :label="$t('addPurchaseApply.itemSpec')" align="center" width="110">
          <template slot-scope="scope">
            {{ scope.row.rssName ? scope.row.rssName : '-' }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('addPurchaseApply.price')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-select v-model="scope.row.timesId" @change="_changeTimesId($event, scope.$index)" style="width:100%">
              <el-option value="" :label="$t('addPurchaseApply.selectPrice')"></el-option>
              <el-option v-for="time in scope.row.times" :key="time.timesId" :value="time.timesId" :label="String(time.price)" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="$t('addPurchaseApply.itemStock')" align="center" width="110">
          <template slot-scope="scope">
            <span class="ds-num">{{ _getTimesStock(scope.row) }}{{ scope.row.unitCodeName }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('addPurchaseApply.applyQuantity')" align="center" min-width="160">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity" type="number" :placeholder="$t('addPurchaseApply.requiredQuantity')" style="width:70%" />
            &nbsp;{{ scope.row.unitCodeName }}
          </template>
        </el-table-column>
        <el-table-column :label="$t('addPurchaseApply.remark')" align="center" min-width="140">
          <template slot-scope="scope">
            <el-input v-model="scope.row.remark" type="text" :placeholder="$t('addPurchaseApply.optionalRemark')" clearable />
          </template>
        </el-table-column>
        <el-table-column :label="$t('addPurchaseApply.operation')" align="center" width="90" fixed="right">
          <template slot-scope="scope">
            <el-button type="danger" size="mini" @click="_removeSelectResourceStoreItem(scope.row.resId)">
              {{ $t('addPurchaseApply.remove') }}
            </el-button>
          </template>
        </el-table-column>
      </ds-data-table>
    </div>

    <div v-if="addPurchaseApplyInfo.audit.assignee == '-2'" class="ds-panel ds-panel--padded">
      <div class="ds-panel__header">
        <span class="ds-panel__title">{{ $t('addPurchaseApply.approver') }}</span>
      </div>
      <el-form label-width="120px">
        <el-form-item :label="$t('addPurchaseApply.approver')">
          <el-col :span="18">
            <el-input type="text" :placeholder="$t('addPurchaseApply.requiredApprover')" disabled v-model="addPurchaseApplyInfo.audit.staffName" />
          </el-col>
          <el-col :span="6">
            <el-button type="primary" @click="chooseStaff">
              <i class="el-icon-search"></i>
              {{ $t('common.select') }}
            </el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </div>

    <choose-resource-store2 ref="chooseResourceStore2" @setSelectResourceStores="handleSetSelectResourceStores" />
    <select-staff ref="selectStaff" @selectStaff="handleStaffChange" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import ChooseResourceStore2 from '@/components/resource/chooseResourceStore2'
import SelectStaff from '@/components/staff/SelectStaff'
import { getUserName } from '@/api/user/userApi'
import { listStorehouses, listResourceSuppliers, queryFirstAuditStaff, purchaseApply } from '@/api/resource/addPurchaseApplyApi'
import { getUserTel } from '../../api/user/userApi'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsToolbar from '@/components/ds/ds-toolbar.vue'
import DsDataTable from '@/components/ds/ds-data-table.vue'

export default {
  name: 'AddPurchaseApply',
  components: { ChooseResourceStore2, SelectStaff, DsPageHeader, DsToolbar, DsDataTable },
  data() {
    return {
      addPurchaseApplyInfo: {
        resourceStores: [], resourceSuppliers: [],
        audit: { assignee: '', staffId: '', staffName: '', taskId: '' },
        description: '', endUserName: '', endUserTel: '', file: '',
        resOrderType: '10000', staffId: '', staffName: '', communityId: '',
        shId: '', storehouses: [], flowId: '', purchaseSwitch: ''
      }
    }
  },
  created() {
    this._reset()
    this.communityId = getCommunityId()
    this.addPurchaseApplyInfo.communityId = this.communityId
    this.addPurchaseApplyInfo.endUserName = getUserName()
    this.addPurchaseApplyInfo.endUserTel = getUserTel()
    this.addPurchaseApplyInfo.purchaseSwitch = this.$route.query.purchaseSwitch
    this._loadResourceSuppliers()
    this._listPurchaseStorehouses()
  },
  methods: {
    _reset() {
      this.addPurchaseApplyInfo = {
        resourceStores: [], resourceSuppliers: [],
        audit: { assignee: '', staffId: '', staffName: '', taskId: '' },
        description: '', endUserName: '', endUserTel: '', file: '',
        resOrderType: '10000', staffId: '', staffName: '', communityId: this.communityId,
        shId: '', storehouses: [], flowId: ''
      }
    },
    _resourcesFromSameHouse(resourcesList) {
      if (!resourcesList || resourcesList.length < 2) return true
      let lastHouse = ''
      for (let i = 0; i < resourcesList.length; i++) {
        if (lastHouse == '') { lastHouse = resourcesList[i].shId; continue }
        if (lastHouse == resourcesList[i].shId) continue
        else return false
      }
      return true
    },
    async _applyPurchaseSummit() {
      const _resourceStores = this.addPurchaseApplyInfo.resourceStores
      if (!_resourceStores || _resourceStores.length < 1) {
        this.$message.error(this.$t('addPurchaseApply.noItemsSelected'))
        return
      }
      if (!this._resourcesFromSameHouse(_resourceStores)) {
        this.$message.error(this.$t('addPurchaseApply.sameWarehouseRequired'))
        return
      }
      let isFlag = true
      let _quantity = true
      this.addPurchaseApplyInfo.resourceStores.forEach(item => {
        if (item.timesId == null || item.timesId == '' || item.timesId == undefined) isFlag = false
        if (item.quantity == null || item.quantity == '' || item.quantity == undefined) _quantity = false
      })
      if (!isFlag) { this.$message.error(this.$t('addPurchaseApply.selectPriceRequired')); return }
      if (!_quantity) { this.$message.error(this.$t('addPurchaseApply.quantityRequired')); return }
      try {
        const res = await purchaseApply(this.addPurchaseApplyInfo)
        if (res.code === 0) { this.$router.go(-1); this.$message.success(this.$t('common.operationSuccess')) }
        else this.$message.error(res.msg)
      } catch (error) { this.$message.error(error) }
    },
    async _loadResourceSuppliers() {
      try {
        const res = await listResourceSuppliers({ page: 1, row: 50 })
        this.addPurchaseApplyInfo.resourceSuppliers = res.data
      } catch (error) { console.error('请求失败:', error) }
    },
    _openSelectResourceStoreInfoModel() {
      const _shId = this.addPurchaseApplyInfo.shId
      const endUserName = this.addPurchaseApplyInfo.endUserName
      const endUserTel = this.addPurchaseApplyInfo.endUserTel
      const description = this.addPurchaseApplyInfo.description
      if (!_shId) { this.$message.error(this.$t('addPurchaseApply.selectWarehouseRequired')); return }
      if (!endUserName) { this.$message.error(this.$t('addPurchaseApply.contactRequired')); return }
      if (!endUserTel) { this.$message.error(this.$t('addPurchaseApply.phoneRequired')); return }
      if (!description) { this.$message.error(this.$t('addPurchaseApply.descRequired')); return }
      this.$refs.chooseResourceStore2.open({ shId: _shId })
    },
    _removeSelectResourceStoreItem(resId) {
      this.addPurchaseApplyInfo.resourceStores.forEach((item, index) => {
        if (item.resId == resId) this.addPurchaseApplyInfo.resourceStores.splice(index, 1)
      })
    },
    _changeTimesId(timeId, index) {
      const times = this.addPurchaseApplyInfo.resourceStores[index].times
      times.forEach((item) => {
        if (item.timesId == timeId) this.addPurchaseApplyInfo.resourceStores[index].selectedStock = item.stock
      })
      this.$nextTick(() => { this.$forceUpdate() })
    },
    _getTimesStock(_resourceStore) {
      if (!_resourceStore.timesId) return '-'
      let _stock = 0
      _resourceStore.times.forEach(_item => { if (_item.timesId == _resourceStore.timesId) _stock = _item.stock })
      return _stock
    },
    async _loadStaffOrg(_flowId) {
      try {
        const res = await queryFirstAuditStaff({ communityId: this.communityId, flowId: _flowId })
        if (res.code != 0) return
        const _data = res.data[0]
        Object.assign(this.addPurchaseApplyInfo.audit, _data)
        if (!_data.assignee.startsWith('-')) this.addPurchaseApplyInfo.audit.staffId = this.addPurchaseApplyInfo.audit.assignee
      } catch (error) { console.error('请求失败:', error) }
    },
    chooseStaff() { this.$refs.selectStaff.open(this.addPurchaseApplyInfo.audit) },
    async _listPurchaseStorehouses() {
      try {
        const res = await listStorehouses({ page: 1, row: 100, communityId: '', allowPurchase: 'ON' })
        this.addPurchaseApplyInfo.storehouses = res.data
      } catch (error) { console.error('请求失败:', error) }
    },
    _computeFlow() {
      this.addPurchaseApplyInfo.resourceStores = []
      const _storehouses = this.addPurchaseApplyInfo.storehouses
      let _flowId = ''
      _storehouses.forEach(item => { if (this.addPurchaseApplyInfo.shId == item.shId) _flowId = item.purchaseFlowId })
      this.addPurchaseApplyInfo.flowId = _flowId
      if (!_flowId) return
      this._loadStaffOrg(_flowId)
    },
    handleSetSelectResourceStores(resourceStores) {
      const oldList = this.addPurchaseApplyInfo.resourceStores
      resourceStores.forEach((newItem, newIndex) => {
        newItem.rsId = ''
        newItem.timesId = ''
        if (newItem.times && newItem.times.length > 0) newItem.timesId = newItem.times[0].timesId
        oldList.forEach((oldItem) => {
          if (oldItem.resId == newItem.resId && newItem.times && newItem.times.length < 2) delete resourceStores[newIndex]
        })
      })
      resourceStores.push.apply(resourceStores, oldList)
      resourceStores = resourceStores.filter((s) => { return s['resId'] })
      this.addPurchaseApplyInfo.resourceStores = resourceStores
    },
    handleStaffChange(staff) {
      this.addPurchaseApplyInfo.audit.staffId = staff.staffId
      this.addPurchaseApplyInfo.audit.staffName = staff.staffName
    },
    goBack() { this.$router.go(-1) }
  }
}
</script>

<style lang="scss" scoped>
.add-purchase-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;
  margin-bottom: var(--ds-spacing-lg);
  &--padded { padding: var(--ds-spacing-lg); }
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);
  }
  &__title {
    font-size: var(--ds-font-size-lg);
    font-weight: 600;
    color: var(--ds-gray-800);
  }
}
.ds-form {
  margin-top: var(--ds-spacing-sm);
}
</style>
